import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { SiteConfigurationServiceSiteConfig } from './types'
import { name } from './symbols'
import { ConfigurationDefinition as definition } from '@wix/site-service-configuration/definition'
import { ConfigurationService as impl } from '@wix/site-service-configuration/implementations'

type ISiteConfigurationDefinition = typeof definition

export const SiteConfigurationService: FactoryWithDependencies<
	ServiceProvider<ISiteConfigurationDefinition, typeof impl>
> = withDependencies(
	[named(SiteFeatureConfigSymbol, name)],
	(
		siteFeatureConfig: SiteConfigurationServiceSiteConfig
	): ServiceProvider<ISiteConfigurationDefinition, typeof impl> => {
		return {
			definition,
			impl,
			config: siteFeatureConfig,
		}
	}
)
